import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { createFromIconfontCN } from '@ant-design/icons';
import './Header.css';
import PlayerLog from '../playerLog/PlayerLog';
import JudgeLog from '../judgeLog/judgeLog';
import Logout from '../logout/Logout';
import { post, get } from '../../Utils/request'
import { message } from 'antd';
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js',
  });


class Header extends Component {
    constructor(props){
        super(props)

        this.state = {
           count: false,
           flag: false,
           logoutflag:false,
           player_name:'',
           judge_name:'',
           is_enroll:false
        }
  
        this.change=this.change.bind(this)
        this.alter=this.alter.bind(this)
        this.logout=this.logout.bind(this)
        this.check=this.check.bind(this)
        // this.entryNologin = this.entryNologin.bind(this)
    }

    change(e){
        this.setState({
            count: !this.state.count,
            flag: false
        })
        this.getdata()
        // this.entryNologin()
        console.log(this.state.count)
    }
    alter(e){
        this.setState({
            flag: !this.state.flag,
            count: false
        })
       this.getdata()
        console.log(this.state.flag)
    }  
    hideMenu = () => {
        this.setState({
           count:false,
           flag:false
        })
        
    }
    // 退出登录
    logout(){
        this.setState({
            logoutflag: !this.state.logoutflag,
        })
    }
    getdata(){
        // console.log(this.props.propsEnroll.match.params.id)
        // if(this.props.search === "?1"||this.props.search==="?2"){
        //     this.setState({
        //         count: true
        //     })
        // }
        if(window.localStorage.userId == 'player'){
            post('/player/info')
            .then(res=>{
                if(window.localStorage.userId == 'player'){
                    console.log(res)
                        this.setState({
                            // userName:res.player_name,
                            // email:res.mail,
                            // company:res.company
                            player_name:res.player_name
                        })
                }
            })
            post('/player/application')
            .then(res=>{
                if(res[0].state==0||res[0].state==1||res[0].state==2){
                    this.setState({
                        is_enroll:true
                    })
                }
                if(res=='未报名'){
                    this.setState({
                        is_enroll:false
                    })
                }
            })
        }
        if(window.localStorage.userId == 'judge'){
            post('/judge/info')
            .then(res=>{
                this.setState({
                    judge_name:res.judge_name
                })
            })
        }
    }
    // entryNologin(){
    //     if(this.props.propsEnroll.match.params.id==='false'||this.props.propsEnroll.match.params.id==='true'){
    //         this.setState({
    //             count: true
    //         })
    //     }
    // }
    componentDidMount(){
        console.log("match",this.props.propsEnroll.match.url)
        let url = this.props.propsEnroll.match.url
        if(url.indexOf("review")<0){
            window.localStorage.PreviousView_page=''
        }
        if(this.props.search === "?1"||this.props.search==="?2"){
            this.setState({
                count: true
            })
        }
        this.getdata()
        //  this.entryNologin()
     
    }
    //报名信息判断
    check(){
        post('/player/application')
        .then(res=>{
            console.log(res[0])
            if(res[0].state==0){
                this.props.push('/registrationexamine')
            }
            if(res[0].state==1){
                this.props.push('/registrationsuccess')
            }
            if(res[0].state==2){
                this.props.push('/registrationfalse')
            }
            if(res=='未报名'){
                this.props.push('/registerednot')
            }
        })
    }

    // 弹出提示
    message(){
        message.warn("报名后才可以上传参赛资料")
    }
    
    // componentDidUpdate(){
       
    //      if(this.props.name === 'enroll'){
    //         if(this.props.location.search === '?login' && this.state.count === false){
    //             this.setState({
    //                 count: true
    //             })
    //         }
    //     }
    
    // }
   
    render() {
        // console.log('header渲染了....')
        // if(this.props.propsEnroll.match.params.id==='false'||this.props.propsEnroll.match.params.id==='true'){
        //     this.setState({
        //         count: true
        //     })
        // } 
        return (

            <div className="header"> 
            {
                this.state.count ? <PlayerLog getdata={this.getdata} push={this.props.push} changeF={this.change} /> : null
            }
            {
                this.state.flag ? <JudgeLog getdata={this.getdata} push={this.props.push} alterF={this.alter} /> : null
            }
            {
                this.state.logoutflag ? <div ><Logout push={this.props.push} logoutF={this.logout} /></div> : null
            }
            <div className="header-wrapper">
                {/* logo */}
                <div className="header-left">
                    <div className="header-logo">
                        <img className="header-logo-img" src="/img/header-logonew.png"/>
                    </div> 
                    <div className="header-left-word">
                       {/* <img  src="/img/header-title-info.png"/> */}
                    </div>
                </div>
                {/* middle */}
                <div className="header-middle">
                    <Link to="/" className="header-middle-one"><sapn className="tit-div1">— </sapn>首页<sapn className="tit-div1"> —</sapn></Link>
                    <Link to="/introduce" className="header-middle-two"><sapn className="tit-div2">— </sapn>大赛介绍<sapn className="tit-div2"> —</sapn></Link>
                    <Link to="/dynamic/1" className="header-middle-three"><sapn className="tit-div3">— </sapn>赛事动态<sapn className="tit-div3"> —</sapn></Link>
                    <Link to="/review" className="header-middle-four"><sapn className="tit-div4">— </sapn>往届回顾<sapn className="tit-div4"> —</sapn></Link>
                    <Link to="/enroll" className="header-middle-five"><sapn className="tit-div5">— </sapn>参赛报名<sapn className="tit-div5"> —</sapn></Link>
                </div>
                
                {
                    window.localStorage.userId == 'player'?
                    <div className="header-img">
                        <img className="userImg" src="/img/player-icon.png"/>
                        <span>{this.state.player_name}</span>
                        <div className="down-arrow"></div>

                        {
                        window.localStorage.userId == 'player'?
                        <ul className="login-menu">
                            <li className="login-menu-li">
                                <Link to="/personalinformation">
                                    <div>个人资料</div>
                                </Link>
                            </li>
                            <li className="login-menu-li">
                                <Link onClick={this.check}>
                                    <div>报名信息</div>
                                </Link>
                            </li>
                            {
                                this.state.is_enroll?
                                <li className="login-menu-li">
                                    <Link to="/entryinformation">
                                        <div>参赛资料</div>
                                    </Link>
                                </li>
                                :
                                <li className="login-menu-li" onClick={this.message.bind(this)}>
                                    <div>参赛资料</div>
                                </li>
                            }
                            <li className="login-menu-li">
                                <Link  onClick={this.logout} >
                                    <div>退出</div>
                                </Link>
                            </li>
                        </ul>
                    :null
                }
                    </div>   
                        
                        
                        :
                      ''
                 
                }
                 {
                    window.localStorage.userId == 'judge'?
                    <div className="header-img">
                        <img className="userImg" src="/img/judge-icon.png"/>
                        <span>{this.state.judge_name}</span>
                        <div className="down-arrow"></div>

                        {
                        window.localStorage.userId == 'judge'?
                        <ul className="login-menu_" >
                            
                            <li className="login-menu-li">
                                <Link to="/caseManagement">
                                    <div>案例评审</div>
                                </Link>
                            </li>
                            <li className="login-menu-li">
                                <Link  onClick={this.logout} >
                                    <div>退出</div>
                                </Link>
                            </li>
                        </ul>
                    :null
                }
                    </div>   
                        
                        
                        :
                   ''
                 
                }
                {
                    window.localStorage.userId ? '':
                <div className="header-right">
                    <img className="header-right-icon" src="/img/header-arrow.png"/>
                    <span onClick={this.change} className="header-right-login">选手登录</span>
                    <span style={{color:"#FAB974"}}> | </span>
                    <span onClick={this.alter} className="header-right-login">评委登录</span>
                </div> 
                }
                 

               
                
            </div> 

            {/* banner图片 */}
            {/* <div className="header-banner">
                <img alt="" src="/img/banner.png" />
            </div> */}
        </div>
    );
}
}

export default Header;